module.exports = __webpack_public_path__ + "static/media/bb.fdab3916.svg";